import { Component, Input, OnInit } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ApexOptions, VexChartComponent } from 'src/@vex/components/vex-chart/vex-chart.component';
import { defaultChartOptions } from 'src/@vex/utils/default-chart-options';
import { createDateArray } from 'src/@vex/utils/create-date-array';

@Component({
  selector: 'vex-widget-large-goal-chart',
  templateUrl: './widget-large-goal-chart.component.html',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, VexChartComponent]
})
export class WidgetLargeGoalChartComponent implements OnInit {
  @Input() title: string = '';  // Dynamic title input
  @Input({ required: true }) total!: string;
  @Input() series: ApexNonAxisChartSeries | ApexAxisChartSeries = [];
  @Input() options: ApexOptions = defaultChartOptions({
    grid: {
      show: true,
      strokeDashArray: 3,
      padding: {
        left: 16
      }
    },
    chart: {
      type: 'line',
      height: 300,
      sparkline: {
        enabled: false
      },
      zoom: {
        enabled: false
      }
    },
    stroke: {
      width: 4
    },
    labels: createDateArray(12),
    xaxis: {
      type: 'datetime',
      ///tickAmount: this.series.length,
     // tickAmount: 10,
      // categories:this.series?.map(el=>el.x),
      

      labels: {
        show: true,
        format: 'dd MMM', // Customize format (e.g., 22 Dec)
        showDuplicates:false
      },
      
    },
    yaxis: {
      labels: {
        show: true
      }
    }
  });

  constructor() {
    console.log(this.series.length);
    
  }

  ngOnInit() {
    // this.options = {
    //   ...this.options,
    //   xaxis: {
    //     ...this.options.xaxis,
    //     tickAmount: 15, // Dynamically set tickAmount based on series length
    //   }
    // };

  }
}
